import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

import { viewSettingsNamePrefix } from 'webapp/models-custom/filter-sort/goal-company';

export default class GoalsCompanyLoadingRouteTemplate extends Component {
	@service('view-settings-manager')
	declare viewSettingsManagerService: Service.ViewSettingsManager;
	@service('account') declare accountService: Service.Account;

	get viewId(): string {
		const settingsName = `${viewSettingsNamePrefix}-${this.accountService.id}`;
		const filterSettings =
			this.viewSettingsManagerService.load<{ viewId: string }>(settingsName, true) || {};
		return filterSettings.viewId || 'grid';
	}

	get skeletonScreenType(): string {
		return this.viewId === 'grid' ? 'tiles' : 'table';
	}

	<template><SkeletonScreenComponent @type={{this.skeletonScreenType}} @item="goal" /></template>
}
